import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { HappContainer } from 'happ-components/HappStyledComponents/HappContainer/HappContainer';
import { HappContentIndicator } from 'happ-components/HappStyledComponents/HappContentIndicator/HappContentIndicator';
import { OverweightIcon, PressureIndicator, ColesterolIndicator, DiabetesIndicator } from 'happ-icons/icons';
import { getScreeningHistoryAction } from 'happ-redux/happ-actions/examHistory/examHistoryActions';
import { useModal } from 'happ-custom-hooks/useModal/useModal';

const ScreeningHistory = () => {
    const {
        ShowScreeningHistoryModal,
        openScreeningHistoryModal,
    } = useModal();
    const dispatch = useDispatch();
    const items = useSelector((state) => state.exams.screeningHistory?.items ?? []);

    useEffect(() => {
        dispatch(getScreeningHistoryAction());
    }, [dispatch]);

    const visibleItems = items.slice(0, 4);
    const count = visibleItems.length;

    const getColProps = (idx) => {
        if (count === 4) return { xs: 12, md: 6, lg: 6 };
        if (count === 3) {
            if (idx < 2) return { xs: 12, md: 6, lg: 6 };
            return {
                xs: 12,
                md: { span: 6, offset: 3 },
                lg: { span: 6, offset: 3 },
            };
        }
        if (count === 2) return { xs: 12, md: 6, lg: 6 };
        if (count === 1) return { xs: 12, md: 12, lg: 12 };
        return { xs: 12 };
    };

    return (
        <Row className="mt-content ">
            <HappContainer>
                <Col className='pt-2 mt-2 mb-3'>
                    <div className='d-flex justify-content-center'>
                        <div className={`text-center px-5 py-2 text-white primary-bg-color  rounded-1 indicators-content`}>
                            <strong className='title-stages' >
                                Resultados de exámenes
                            </strong>
                        </div>
                    </div>
                </Col>
                {count > 0 ? (
                    <div className="indicators-content">
                        <Row className="px-2">
                            {visibleItems.map((item, idx) => (
                                <Col
                                    key={item.id ?? idx}
                                    {...getColProps(idx)}
                                    className="px-0 pt-4 col-indicator-mobile"
                                >
                                    <HappContentIndicator
                                        className="box-content primary-bg-color mb-4"
                                        onClick={openScreeningHistoryModal(item.pathologyName, item.exams)}
                                        role="button"
                                    >
                                        <Row>
                                            {item.pathologyName === 'Hipertensión' ?
                                                (
                                                    <>
                                                        <div className='my-2'>
                                                            <PressureIndicator
                                                                fill='white'
                                                                responsive='scale-mobile'
                                                            />
                                                        </div>
                                                    </>
                                                ) : item.pathologyName === 'Obesidad' ?
                                                    (
                                                        <>
                                                            <div className='my-2'>
                                                                <OverweightIcon
                                                                    fill='white'
                                                                    responsive='scale-mobile'
                                                                />
                                                            </div>
                                                        </>
                                                    ) : item.pathologyName === 'Diabetes' || item.pathologyName === 'Pre diabetes' ?
                                                        (
                                                            <>
                                                                <div className='my-2'>
                                                                    <DiabetesIndicator
                                                                        fill='white'
                                                                        responsive='scale-mobile'
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : item.pathologyName === 'Dislipidemia' ? (
                                                            <>
                                                                <div className='my-2'>
                                                                    <ColesterolIndicator
                                                                        fill='white'
                                                                        responsive='scale-mobile'
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : null}
                                        </Row>
                                        <Row className="border-bottom-container blue-border">
                                            <Col>
                                                <p>
                                                    {item.pathologyName === 'Hipertensión' ?
                                                        (
                                                            <>
                                                                <p>Presión Arterial</p>
                                                            </>
                                                        ) : item.pathologyName === 'Obesidad' ?
                                                            (
                                                                <>
                                                                    <p> Chequeo <strong>IMC</strong> </p>
                                                                </>
                                                            ) : item.pathologyName === 'Diabetes' || item.pathologyName === 'Pre diabetes' ?
                                                                (
                                                                    <>
                                                                        <p>Diabetes</p>
                                                                    </>
                                                                ) : item.pathologyName}
                                                </p>
                                            </Col>
                                        </Row>
                                    </HappContentIndicator>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ) : null}
                <ShowScreeningHistoryModal />
            </HappContainer>
        </Row>
    );
}

export default ScreeningHistory;